import React, { useState } from "react";
import { SvgIcons } from "../../../SharedComponents/SvgIcons/SvgIcons";
import styles from "./ParentPreferredSchedule.module.css";

/**
 * Collapsible "Parent's preferred schedule" strip at the top of the Schedule
 * section (R-01-08). The backend answers from one of several stores, each with
 * its own fields; the mapper flattens whichever it got into labelled rows (a day
 * and its slots, or a heading and its values) and plain facts, so this renders
 * any source the same way. `isEmpty` is the "none recorded" state (R-04-01).
 *
 * @param {{ preference: {classesPerWeek?: number|null,
 *                        rows: {label: string, values: string[]}[],
 *                        facts: {label: string, value: string}[],
 *                        isEmpty: boolean}|null }} props
 */
const ParentPreferredSchedule = ({ preference }) => {
  const [open, setOpen] = useState(true);

  if (!preference) return null;

  return (
    <div className={styles.wrap}>
      <button
        type="button"
        className={styles.header}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <span className={styles.headerLabel}>Parent&rsquo;s preferred schedule:</span>
        {preference?.isEmpty && <span className={styles.none}>None recorded</span>}
        {preference?.classesPerWeek > 0 && (
          <span className={styles.countChip}>{preference?.classesPerWeek} classes / week</span>
        )}
        <SvgIcons
          name="chevron_down"
          className={open ? styles.chevronOpen : styles.chevron}
          width="20"
          height="20"
        />
      </button>
      {open && !preference?.isEmpty && (
        <div>
          {/* The backend answers from the first store that holds anything, and some
              hold only a start date or a mentor. Said outright, so a strip with one
              fact reads as what was recorded rather than as a broken one. */}
          {!preference?.rows?.length && !preference?.classesPerWeek && (
            <p className={styles.noDays}>The parent didn&rsquo;t choose any days or times.</p>
          )}
          {preference?.rows?.map((row) => (
            <div key={row?.label} className={styles.dayRow}>
              <span className={styles.dayName}>{row?.label}</span>
              <span className={styles.slots}>
                {row?.values?.map((value) => (
                  <span key={value} className={styles.slotChip}>
                    {value}
                  </span>
                ))}
              </span>
            </div>
          ))}
          {preference?.facts?.map((fact) => (
            <div key={fact?.label} className={styles.dayRow}>
              <span className={styles.dayName}>{fact?.label}</span>
              <span className={styles.fact}>{fact?.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ParentPreferredSchedule;
